export enum ActionStyles {
    primary = "primary",
    secondary = "secondary",
    destructive = "destructive"
}